import { env } from "../import-meta-env";
export const showElementWithoutImplementation: boolean =
  env.VITE_SHOW_ELEMENT_WITHOUT_IMPLEMENTATION === "true";
